export default "__VITE_ASSET__D4vUeQ6Z__"